import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Loader from "../../Components/Loader";

import { useAuth } from "../../Context/Context";

import icon2 from "../../Images/Icon/63.png";

import useStorage from "../../Hooks/useStorage";
import AutoresBlogsHelper from "../../Helpers/AutoresBlogs";

const View = () => {
  const { setEditar } = useAuth();

  const [autores, setAutores] = useState([]);
  const [flag, setFlag] = useState(false);
  const [id, setId] = useState("");

  // uso de hooks para agregar imagen a google storage
  const [consulta, setConsulta] = useState("");
  let [response] = useStorage(consulta);

  useEffect(() => {
    if (!response) {
      obtenerAutores();
    } else {
      if (response.action === "eliminar") {
        eliminarProfesor();
      }
    }
  }, [response]);

  const obtenerAutores = async () => {
    let res = await AutoresBlogsHelper.obtnenreAutores();
    if (res.success) {
      setAutores(res.data);
      setFlag(true);
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener los autores, codigo: " + res.code,
        "error"
      );
    }
  };

  const eliminarProfesor = () => {
    AutoresBlogsHelper.eliminarAutor(id);
  };

  const eliminarArchivo = (autor) => {
    setId(autor._id);

    setConsulta({
      consulta: "eliminar",
      url: "/autores-blogs",
      urlFile: autor.imagen,
    });
  };

  const agregarAutor = () => {
    let ventana = document.getElementById("ventana_editable_agregar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar_agregar");
    cerrar.className = "invisible_cerrar_activado";
  };

  const editarAutor = (autor) => {
    let ventana = document.getElementById("ventana_editable_editar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar");
    cerrar.className = "invisible_cerrar_activado";
    setEditar(autor);
  };

  return (
    <div id="vistas_generales" className="col s12" style={{ padding: "0" }}>
      <div className="container center">
        <p className="titulo_solicitud" style={{ textAlign: "center" }}>
          Autores para los blogs
        </p>
        {!flag ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
            }}
          >
            <Loader />
          </div>
        ) : (
          <div>
            <p style={{ marginLeft: "25px" }} className="texto_solicitud">
              Nombre
            </p>
            <div>
              {autores.map((autor) => (
                <div className="box_solicitud">
                  <div className="row">
                    <div className="col s10">
                      <div
                        style={{
                          marginLeft: "25px",
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={autor.imagen}
                          alt={autor.nombre}
                          style={{
                            width: "100px",
                            borderRadius: "50%",
                            marginRight: "50px",
                          }}
                        />
                        <p
                          className="texto_solicitud"
                          style={{ fontWeight: "bold" }}
                        >
                          {autor.nombre}
                        </p>
                        <p className="texto_solicitud">{autor.certificado}</p>
                      </div>
                    </div>
                    <div className="col s2">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingRight: "25px",
                          height: "103px",
                        }}
                      >
                        <img
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            eliminarArchivo(autor);
                          }}
                          src={icon2}
                          alt=""
                        />
                        <button
                          onClick={() => {
                            editarAutor(autor);
                          }}
                          className="caja_status"
                          style={{ backgroundColor: "#00496C", border: "none" }}
                        >
                          <p>EDITAR</p>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="boton_2_nv">
            <button onClick={agregarAutor}>
              <p>Agregar autor</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
